export default {
  sm: `
  DATA CENTER GAK is a best practice 
  example of a next-generation data center 
  that creates numerous values by storage 
  and analysis of large-scale data.
  `,
  md: `
  DATA CENTER GAK is a best practice example 
  of a next-generation data center that 
  creates numerous values by storage and 
  analysis of large-scale data.
  `,
  lg: `
  DATA CENTER GAK is a best practice example of 
  a next-generation data center that creates 
  numerous values by storage and analysis of 
  large-scale data.
  `,
  xxl: `
  DATA CENTER GAK is a best practice example of a next-
  generation data center that creates numerous values by 
  storage and analysis of large-scale data.
  `,
};
